
import {  apiCalls,authApiCalls } from './apiCalls';



let config = {
  base_url_2:"https://pulsedb-qa.pulselabs.co.in"
}

export const getAuthToken = () => {
  const url = config.base_url_2 + `/rest/api/v1/partner_login`;
  const reqObject = {
      // "partner": "Stack-Demo",
      // "key": "Stack-Demo"
      "partner": "Pulse-Demo",
      "key": "Pulse$007"
  };
  return apiCalls('post', url, reqObject);
}



  export const getAnnualPerformanceData = (values) => {
    const url = config.base_url_2 + `/rest/api/v1/mf/annual_returns`;
    const reqObject = {
        "auth": values.auth,
        "scheme_code": values.scheme_code,
        "years": values.years
    }
    return apiCalls('post', url, reqObject);

}

export const getTrailingData = (scheme_code, fromYears) => {
  const url = config.base_url_2 + `/rest/api/v1/mf/comparision/trailing`;
  const reqObject = {
      "auth": "{{auth_token}}",
      "scheme_codes": scheme_code,
      "from": fromYears,
      "ranges": "1M,3M,6M,9M,1Y,3Y,5Y,7Y"
  }
  return apiCalls('post', url, reqObject);

}

export const getDiscreteData = (discreteValues) => {
  const url = config.base_url_2 + `/rest/api/v1/mf/comparision/discrete`;
  const reqObject = {
      "auth": discreteValues.auth,
      "scheme_codes": discreteValues.scheme_code,
      "from": discreteValues.fromYears,
      "frequency": discreteValues.frequency
  }
  return apiCalls('post', url, reqObject);

}

export const getRiskAnalysisData = (riskValues) => {
  const url = config.base_url_2 + `/rest/api/v1/risk/parameters`;
  const reqObject = {
      "auth": riskValues.auth,
      "scheme_codes": riskValues.scheme_code,
      "from": riskValues.from,
      "ranges": riskValues.ranges
  }
  return apiCalls('post', url, reqObject);

}


export const getAnalyticalData = (values) => {
  const url = config.base_url_2 + `/rest/api/v1/mf/analytical-data`;
  const reqObject = {
      "auth": values.auth,
      "scheme_code": values.scheme_code,
  }
  return apiCalls('post', url, reqObject);
}

export const getTopSecurities = (values) => {
 // console.log(values)
  const url = config.base_url_2 + `/rest/api/v1/mf/scheme_holdings_security`;
  const reqObject = {
      "auth": values.auth,
      "scheme_code": values.scheme_code,
      "as_on": values.as_on,
    "portfolio_type":values.portfolio_type
  }
  return apiCalls('post', url, reqObject);

}

export const getTopSector = (values) => {
  // console.log(values)
   const url = config.base_url_2 + `/rest/api/v1/mf/scheme_holdings_sector`;
   const reqObject = {
       "auth": values.auth,
       "scheme_code": values.scheme_code,
       "as_on":  values.as_on,
     "portfolio_type":values.portfolio_type
   }
   return apiCalls('post', url, reqObject);
 
 }

 export const getAmcInfo = (values) => {
  // console.log(values)
   const url = config.base_url_2 + `/rest/api/v1/screener/amc_info`;
   const reqObject = {
       "auth": values.auth,
       "amc_name":values.amc_name,
       "amc_code":""
   }
   return apiCalls('post', url, reqObject);
 }

 export const getNavHistory = (values) =>{
  const url = config.base_url_2 + '/rest/api/v1/mf/nav-history';
  const reqObject = {
    "auth": values.auth,
    "scheme_code": values.schemeCode,
    "from": values.fromYears,
    "to": values.toYears,
   "frequency":values.frequency,
  };
 // console.log(reqObject);
  return authApiCalls('post', url, reqObject);
}

export const getSubAssetCategories = (auth, amc_codes, asset_category) => {
  const url = config.base_url_2 + `/rest/api/v1/mf/asset_sub_categories`;
  let reqObject = {
      "auth": auth,
      "asset_category": asset_category ,
      "amc_codes": amc_codes
  };
  return apiCalls('post', url, reqObject);
}

export const getScheme = (scheme, optionName) => {
  const url = config.base_url_2 + `/rest/api/v1/mf/search`;
  const reqObject = {
    search_text: scheme || "adi fro",
    plan_name: "broker",
    option_name: optionName === "idcw" ? "idcw" : "growth",
    amc_codes: "",
    bse_txn: "Y",
  };
  return authApiCalls("post", url, reqObject);
};
